const Config = require('~/config/default.env').default;

export default {
  state: {
    userimage: null,
    userfirstname: '',
    userlastname: '',
    userFullName: '',
    user_name: '',
    username: '',
    user_id: '',
    userProfile: '',
    loggedin: false,
    modalAuth: 0,
    modalAuthMode: '',
    points: {},
    token: '',
    showMessageLimit: false,
    showMessageLimitCount: false,
    showMessageUserDeleted: false,
    // enableCheck: {
    //   methods: ['sms', 'whatsapp', 'email'],
    //   result: [],
    // },
    mandatoryUserInfo: ['user_name', 'first_name', 'last_name', 'email', 'phone_no', 'gender'],
    meCalled: false,
  },
  mutations: {
    loggedIn(state, data) {
      state.loggedin = data;
    },
    setMessageLimit(state, data) {
      state.showMessageLimit = data;
    },
    setMessageLimitCount(state, data) {
      state.showMessageLimitCount = data;
    },
    setMessageUserDeleted(state, data) {
      state.showMessageUserDeleted = data;
    },
    setRedirectState(state, newVal) {
      state.redirectState = newVal;
    },
    setRedirectURL(state, newVal) {
      state.globalRedirectUrl = newVal;
    },
    userProfile(state, data) {
      state.userProfile = data;
    },
    userProfileCoachMark(state, data) {
      state.userProfile['coachmark_visited'] = data;
    },
    userImage(state, image) {
      state.userimage = image;
    },
    profileState(state, data) {
      if (data && Object.keys(data).length) {
        if (data.image || data.image == '') {
          state.userimage = data.image;
        } else {
          state.userimage = '/assets/img/avatar-soco.png';
        }
        if (data.name) {
          state.userFullName = data.name;
        } else if ((!data.name || data.name == '') && data.first_name && data.last_name) {
          state.userFullName = data.first_name + ' ' + data.last_name;
        }
        if (data.first_name || data.first_name == '') {
          state.userfirstname = data.first_name;
        }
        if (data.last_name || data.last_name == '') {
          state.userlastname = data.last_name;
        }
        if (data.user_name || data.user_name == '') {
          state.user_name = data.user_name;
          state.username = data.user_name;
        }
        if (data._id || data._id == '') {
          state.user_id = data._id;
        }
      }
    },
    modalAuth(state, data) {
      state.modalAuth = data;
    },
    modalAuthMode(state, data) {
      state.modalAuthMode = data;
    },
    setMessageLogin(state, data) {},
    setUserPoints(state, data) {
      state.points = data;
    },
    setToken(state, data) {
      state.token = data;
    },
    // setResultEnabledOtp(state, data) {
    //   state.enableCheck.result = data;
    // },
    meCalled(state, value) {
      state.meCalled = value;
    },
  },
  actions: {
    loginOtf({ commit, state, dispatch }) {
      commit('modalAuth', 1);
      commit('modalAuthMode', 'otf');
      dispatch('lockBg', true);
    },
    lockBg({ commit, state, dispatch }, data) {
      const parent = document.getElementById('app');
      if (parent) {
        if (data) {
          parent.classList.add('no-scroll');
        } else {
          parent.classList.remove('no-scroll');
        }
      }
    },
    setCoachMark({ state, commit, rootState, dispatch }, payload) {
      let data = state.userProfile.coachmark_visited;
      if (data.indexOf(payload.coachmark) < 0) {
        data = data.concat(payload.coachmark);
      }
      axios
        .put(Config.SITE_SOCO + 'users/' + payload.id, {
          coachmark_visited: data,
        })
        .then((response) => {
          if (response.status === 200) {
            commit('userProfileCoachMark', data);
          }
        })
        .catch((error) => {});
    },
    // otpServiceEnableCheck({ state, commit }) {
    //   return axios
    //     .get(`${Config.MS_SOCO_PUBLIC_API_URL}/feature-toggles`, {
    //       params: { filter: { feature_name: { $in: ['otp_sms', 'otp_whatsapp', 'otp_email'] } } },
    //     })
    //     .then((response) => {
    //       return response.data.data;
    //     })
    //     .then((resp) => {
    //       commit('setResultEnabledOtp', resp);
    //     });
    // },
    completeProfileURL({ state }, user) {
      const params = state.mandatoryUserInfo.reduce((result, info) => {
        if (user && user.hasOwnProperty(info) && Boolean(user[info])) {
          result += `&${info}=${user[info]}`;
        }
        return result;
      }, '');
      return `${Config.SOCO_WEB_URL}/third-party-complete-profile?origin=review&acquisition_source=${
        user ? user.acquisition_source : ''
      }${params}`;
    },
    incompleteUserInfo({ state }, user) {
      return state.mandatoryUserInfo.some((info) => !Boolean(user[info]));
    },
    userBlockedToReviewCheck({ commit, getters }) {
      if (getters.userBlockedReviews && Object.keys(getters.userBlockedReviews).length) {
        const diffHours = Math.abs(new Date() - new Date(getters.userBlockedReviews.blocked_at)) / 36e5;
        if (getters.userBlockedReviews.count > 2 && diffHours < 1) {
          commit('setReviewErrorMessage', 'Hai, kamu gagal mengirim review sebanyak 3x. Coba lagi dalam satu jam.');
          commit('toggleModalGlobalState', { modalName: 'reviewError' });
          return true;
        }
      }
      if (getters.userBannedCertainMinutes) {
        const diffHours = Math.abs(new Date() - new Date(getters.userBannedCertainMinutes)) / 36e5;
        if (diffHours < 6) {
          commit(
            'setReviewErrorMessage',
            'Hai, kamu sudah mengirim 20 review dalam 15 menit terakhir. kamu bisa mengirim review kembali dalam 6 jam.'
          );
          commit('toggleModalGlobalState', { modalName: 'reviewError' });
          return true;
        }
      }
    },
  },
  getters: {
    // smsEnabled: (state) => {
    //   const sms = (state.enableCheck.result || []).find(
    //     (res) => res.method === 'sms' || res.feature_name === 'otp_sms'
    //   );
    //   return sms.isEnable || sms.isToggleOn || false;
    // },
    // whatsappEnabled: (state) => {
    //   const whatsapp = (state.enableCheck.result || []).find(
    //     (res) => res.method === 'whatsapp' || res.feature_name === 'otp_whatsapp'
    //   );
    //   return whatsapp.isEnable || whatsapp.isToggleOn || false;
    // },
    // emailEnabled: (state) => {
    //   const email = (state.enableCheck.result || []).find(
    //     (res) => res.method === 'email' || res.feature_name === 'otp_email'
    //   );
    //   return email.isEnable || email.isToggleOn || false;
    // },
    userBlockedReviews: (state) => {
      if (state.userProfile) {
        return state.userProfile.user_blocked_reviews;
      } else {
        return {};
      }
    },
    userBannedCertainMinutes: (state) => {
      if (state.userProfile) {
        return state.userProfile.user_banned_certain_minutes_spam_at;
      } else {
        return null;
      }
    },
  },
};
